import { US, ES, BR, FR, DE } from 'country-flag-icons/react/3x2' // assuming tree-shaking works
import outputs from 'root/cfOutput'

const { domainName } = outputs
// eslint-disable-next-line import/prefer-default-export
export const Weglot = {
	scriptUrl: 'https://cdn.weglot.com/weglot.min.js',
	// Note: see the full list of options: https://developers.weglot.com/javascript/options
	initScript: key => `Weglot.initialize({
		"api_key": "${key}",
		"cache": true,
		"hide_switcher": true
	})`,
	languageCodes: [
		'en',
		'es',
		'br',
		'fr',
		'de',
	],
	origins: [
		`https://${domainName}`,
		`https://es.${domainName}`,
		`https://pt-br.${domainName}`,
		`https://fr.${domainName}`,
		`https://de.${domainName}`,
	],
	dnsSettings: {
		type: 'CNAME',
		value: 'websites.weglot.com.',
		names: [
			`es.${domainName}`,
			`pt-br.${domainName}`,
			`fr.${domainName}`,
			`de.${domainName}`,
		],
	},
	flagComponents: {
		en: US,
		es: ES,
		br: BR,
		fr: FR,
		de: DE,
	},
	languageNames: {
		en: 'English',
		es: 'Español',
		br: 'Português',
		fr: 'Français',
		de: 'Deutsch',
	},
}
